import * as React from 'react';
import PropTypes from 'prop-types';
import Button from '@mui/material/Button';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import {
    Box,
    Checkbox,
    DialogActions,
    DialogContent,
    FormControlLabel,
    Grid,
    TextField,
    Typography
} from "@mui/material";
import {createElement, useEffect, useState} from "react";
import {styled} from "@mui/material/styles";
import {useCreateOrderMutation} from "../../core/api/order-api";
import {useSelector} from "react-redux";
import ResponseDialog from "../ResponseDialog";
import {Alert, Autocomplete, LoadingButton} from "@mui/lab";
import BcIcon from "../../img/CoinOrange.png";
import {useGetAllUsersDetailsQuery} from "../../core/api/users-api";
import GiftLocation from "./GiftLocation";
import ProductPrice from "../Common/PriceComponent";
import ReportProblemOutlinedIcon from "@mui/icons-material/ReportProblemOutlined";

const Img = styled('img')({
    margin: 'auto',
    display: 'block',
    maxWidth: '100%',
    maxHeight: '100%',
});

export default function CreateGiftDialog(props) {
    const {onClose, open, product, variation, inStock} = props;
    const sessionState = useSelector((state) => state.data.UserSession);
    const [crateOrder, createOrderResponse] = useCreateOrderMutation();
    const {data: usersDetails = [], isFetching, isSuccess} = useGetAllUsersDetailsQuery();

    const userSelectedLocation = sessionState.usersDetails.location;

    const isCountryWithoutOffice = (country) => {
        return country === "Россия" || country === "Украина" || country === "Польша";
    }
    const isDeliveryToOffice = userSelectedLocation !== "Другое" &&
        !isCountryWithoutOffice(userSelectedLocation);

    const [state, setState] = useState({
        deliveryAddress: "",
        price: product.isSale ? product.salePrice : product.price,
        receiverFullName: "",
        receiverLocation: "",
        comment: "",
        isProductAvailable: false,
        isCreateButtonClick: false,
        isRequestLoading: false,
        errors: {}
    })


    useEffect(() => {
        const isResponseLoadingDialog = state.isCreateButtonClick && (createOrderResponse.status !== 'rejected' || createOrderResponse.status !== 'fulfilled');
        const isReadyToDialog = (createOrderResponse.status === 'rejected' || createOrderResponse.status === 'fulfilled');
        setState({
            ...state,
            isRequestLoading: isResponseLoadingDialog,
            isCreateButtonClick: false
        })
        if (isReadyToDialog) {
            let dialogResponseInformationElement = null;
            let dialogResponseInformation = "";
            if (createOrderResponse.data) {
                dialogResponseInformationElement = createOrderResponse.data.asanaLink.includes('http') ?
                    createElement('a', {href: createOrderResponse.data.asanaLink}, createOrderResponse.data.asanaLink) :
                    createElement('p', null, createOrderResponse.data.asanaLink);
                dialogResponseInformation = "Link to the order task:"
                setState({
                    ...state,
                    isRequestLoading: false,
                })


            } else {
                setState({
                    ...state,
                    isRequestLoading: false,
                });
            }
            handleClose(true, {
                response: createOrderResponse,
                dialogResponseInformationElement: dialogResponseInformationElement,
                dialogResponseInformation: dialogResponseInformation,
            });
        }

    }, [createOrderResponse])


    const handleClose = (orderResponseReady, responseData) => {
        setState({
            ...state,
            isRequestLoading: false,
            isCreateButtonClick: false,
            receiverFullName: "",
            receiverLocation: "",
            errors: {},

        })
        onClose({
            isResponseReady: orderResponseReady === true,
            data: responseData
        });
    };

    const handleCreateOrder = () => {
        if (validateRequiredFields()) {
            state.deliveryAddress = state.postcode + ", " + state.country + ", " + state.city + ", " + state.address + ", ";
            crateOrder({
                productId: product.id,
                deliveryAddress: state.receiverLocation,
                variation: variation,
                isDeliveryToOffice: isDeliveryToOffice,
                productLink: window.location.href,
                receiverFullName: state.receiverFullName,
                isGift: true,
                comment: state.comment,
                isProductInStock: inStock,
                isCharity: false
            })
        }
    }

    const validateRequiredFields = () => {
        let errors = {};
        if (state.receiverFullName.trim() === "") {
            errors = {...errors, receiverFullName: true}
        }
        setState({
            ...state,
            errors: errors,
            isCreateButtonClick: true
        })

        return Object.keys(errors).length === 0;
    }

    const handleSelectEmployee = (employee) => {
        setState({
            ...state,
            receiverFullName: employee != null ? employee.fullName : "",
            receiverLocation: employee != null ? employee.location : ""
        })
    }

    const handleChangeAvailability = (value) => {
        setState({
            ...state,
            isProductAvailable: value
        })
    }

    const handleCustomUserPhoneChange = (event) => {
        setState({
            ...state,
            comment: event.target.value
        })
    }

    return (
        <Dialog onClose={handleClose} open={open} fullWidth maxWidth="md">
            <DialogTitle>
                Ordering a gift for a colleague
            </DialogTitle>
            <DialogContent>
                <Typography sx={{mb: 3, textAlign:'center',pt:1}} gutterBottom variant="body1" component="div">
                    <b>Your account will be charged</b> <span className={"inline-price"}>
                                <ProductPrice price={state.price}/>
                            </span>

                </Typography>
                <Grid container spacing={2}>
                    <Grid item xs={12} sm={4}>
                        <div className="create-order__image-wrap">
                            <Img
                                key={`product_image`}
                                sx={{width: "100%"}}
                                alt={product.title}
                                src={product.images[0]}/>
                        </div>

                    </Grid>
                    <Grid item xs={12} sm={8}>

                        <Typography gutterBottom variant="body1" component="h3">
                            {product.title}
                        </Typography>
                        <Typography gutterBottom variant="body1" component="div">
                            <div dangerouslySetInnerHTML={{ __html: product.description}}/>
                        </Typography>
                        {
                            variation ?
                                <Typography gutterBottom variant="body1" component="div">
                                    Size : {variation}
                                </Typography> : null
                        }
                        {
                            !inStock &&
                            <Alert
                                icon={<ReportProblemOutlinedIcon
                                    style={{ color: '#ff0000' }}
                                    fontSize="inherit" />}
                                severity="warning">
                                <p><strong>This product is out of stock.</strong>
                                Once you place the order, the shop administrator will let you know the estimated fulfillment time. <br/>
                                *tech orders are handled individually in all locations. Estimated waiting time is 2-4 weeks. </p>
                                <p><strong>Important!</strong>
                                When ordering, keep in mind that the selected product may be available in a limited quantity/batch (with no possibility of reproduction). In that case your order may be cancelled by the administrator, and you will receive a notification. <br/>
                                * the estimated time for processing and delivering merch may be 2-3 months (if there are no restrictions on the batch). <br/>
                                * merch delivery to the Belarus location may take up to 2-4 months.
                                </p>
                            </Alert>
                        }
                        <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={usersDetails}
                            sx={{mt: 4}}
                            onChange={(event, newValue) => {
                                handleSelectEmployee(newValue);
                            }}
                            renderInput={(params) =>
                                <TextField {...params}
                                           variant="outlined"
                                           color="warning"
                                           name="receiverFullName"
                                           error={state.errors.receiverFullName}
                                           helperText={state.errors.receiverFullName
                                               ? "This field cannot be empty."
                                               : ""}
                                           label="Choose a colleague"/>}
                        />
                        <GiftLocation
                            productId={product.id}
                            receiverLocation={state.receiverLocation}
                            setAvailability={handleChangeAvailability}
                        />
                        <TextField
                            sx={{mt: 2}}
                            value={state.comment}
                            id="comment"
                            label="Message for the recipient"
                            variant="outlined"
                            color="warning"
                            onChange={handleCustomUserPhoneChange}
                            fullWidth
                            name="comment"
                        />
                    </Grid>
                </Grid>

            </DialogContent>
            <DialogActions>
                <Button
                    size="small"
                    color="secondary"
                    onClick={handleClose}>
                    Cancel
                </Button>
                <LoadingButton
                    size="small"
                    variant="outlined"
                    color="warning"
                    onClick={handleCreateOrder}
                    loading={state.isRequestLoading}
                    disabled={!state.isProductAvailable}>
                    Place order
                </LoadingButton>
            </DialogActions>
        </Dialog>
    );
}

CreateGiftDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    product: PropTypes.object.isRequired,
    variation: PropTypes.string.isRequired,
    inStock: PropTypes.bool.isRequired
};
